import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

interface LoaderState {
  isLoading: boolean;
}

const initialState: LoaderState = {
  isLoading: false,
};

export const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    show: (state) => {
      state.isLoading = true;
    },
    hide: (state) => {
      state.isLoading = false;
    },
  },
});

export const { show, hide } = loaderSlice.actions;
export const selectIsLoading = (state: RootState) => state.loader.isLoading;

export default loaderSlice.reducer;
